<template>
    <section>
        <div v-if="!showCreateAccountForm" style="width:100%">
            <div v-if="!hideLoginSignup" class="loginFormWrapper">
                <LoginForm :login-form="loginForm" />
            </div>
            <div v-else class="registerFormWrapper">
                <RegisterForm
                    :create-account-form="createAccountForm"
                    :register-form="registerForm"
                />
            </div>
        </div>

        <div v-if="showCreateAccountForm" class="CreateAccountFormWrapper">
            <CreateAccount />
        </div>
    </section>
</template>
<script>
import LoginForm from '@/components/LoginPageComp/LoginForm.vue'
import RegisterForm from '@/components/LoginPageComp/RegisterForm.vue'
import CreateAccount from '@/components/LoginPageComp/CreateAccount.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
    components: {
        LoginForm,
        RegisterForm,
        CreateAccount
    },
    data: () => ({
        createAccountForm: true,
        loginForm: true,
        registerForm: false
    }),
    computed: {
        ...mapGetters(['hideLoginSignup', 'showCreateAccountForm'])
    },
    methods: {
        // getCsrf() {
        //   axios.create({withCredentials: true}).get(`${process.env.VUE_APP_API}/signup/getCsrfToken`).then((response) => {
        //     axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrfToken;
        //     // console.log('token in vue: ', response.data.csrfToken);
        //   }, (err) => {
        //     console.error(err);
        //   });
        // }
        ...mapActions(['getCsrfToken'])
    }
}
</script>

<style scoped>
section {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 100%;
  background-image: url("../assets/loginBG.webp");
  background-position: center;
  background-size: cover;
}
.header {
  height: 10%;
  width: 100%;
  position: fixed;
  top: 0;
  padding: 20px;
}
.header h1 {
  font-size: 30px;
}
.whiteCross {
  width: 5%;
  padding: 10px;
}
.whiteCross img {
  width: 100%;
}

.registerFormWrapper,
.loginFormWrapper,
.CreateAccountFormWrapper {
  width: 100%;
}
/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
@media (max-width: 599px) {
  .whiteCross {
    display: none;
  }
  .header h1 {
    display: none;
  }
}
@media (min-width: 599px) and (max-width: 968px) {
  section {
    height: 100%;
  }
}
</style>
